import React, { useEffect, useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import Tooltip, { POINTER_POSITION } from '@components/Tooltip';
import showSectionMenu from '@shopDetails/utils/menu';
import Toast from './components/Toast';
import Text from './components/Text';
import connect from './connect';

const ToastFavoriteDish = ({
  status,
  hideToast,
  isMenuSection,
  target = null,
  menuSections,
}) => {
  const { show, title } = status;

  const hasMenuSections = useMemo(() => showSectionMenu(menuSections), [
    menuSections,
  ]);

  useEffect(() => {
    let timer = null;
    if (show) {
      timer = setTimeout(() => hideToast(), 3000);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [hideToast, show]);

  if (isMenuSection && !hasMenuSections) {
    return (
      show && (
        <Tooltip
          target={target}
          content={<Text>{title}</Text>}
          pointerPosition={POINTER_POSITION.TOP_LEFT}
        />
      )
    );
  }

  if (hasMenuSections) {
    return (
      show && (
        <Toast>
          <Text>{title}</Text>
        </Toast>
      )
    );
  }

  return null;
};

ToastFavoriteDish.propTypes = {
  status: PropTypes.shape({
    title: PropTypes.string.isRequired,
    show: PropTypes.bool.isRequired,
  }),
  hideToast: PropTypes.func.isRequired,
  isMenuSection: PropTypes.bool,
  target: PropTypes.object,
  menuSections: PropTypes.array.isRequired,
};

export default connect(memo(ToastFavoriteDish));
